import { GDMState } from "@/libs/graphics/types/Graphics.t";
import { Module } from "vuex";
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const moduleGdm: Module<GDMState, any> = {
  getters,
  actions,
  mutations,
  namespaced: true,
  state: {
    config: [],
    data: []
  }
};

export default moduleGdm;